import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import FuseButton from '../FuseControls/FuseButton';
import BrowserStore from '../../browser/stores/BrowserStore';
import './FloatingIcon.css';

const block = b.lock('FloatingIcon');

class FloatingIcon extends Component {
    render() {
        const { browser } = this.props;

        return (
            <FuseButton
                type={FuseButton.type.PRIMARY}
                color={FuseButton.color.BLUE}
                icon={'floatingIcon'}
                className={block('FloatingIconBtn')}
                iconClassName={block('FloatingIcon')}
                wrapperClassName={block('FloatingIconWrapper')}
                onClick={(event) => {
                    event.stopPropagation();
                    browser.topBarMenu.toggle();
                }}
            />
        );
    }
}

FloatingIcon.propTypes = {
    browser: BrowserStore.PropType.isRequired,
};

export default inject('browser')(observer(FloatingIcon));
